import BrandsList from './BrandsList';
import FooterPrivacy from './FooterPrivacy';
import ImageLogo from '../../../../assets/images/white-logo.png';
import { isSiteCanadian } from '../../../../utils/helpers';
import LanguageSelector from './languageSelector';
import React from 'react';

import './styles.scss';

const BaseTemplate: React.FC = ({ children }) => {
    const isCanadian = isSiteCanadian();

    return (
        <div className={'o-layout'}>
            <div className={'o-layout__item u-1/1@s u-1/1@m main'}>
                <div className={'logo-top-section'}>
                    <div className={'logo-top-section-black'}>
                        <img src={ImageLogo} alt={'logo'} />
                    </div>
                    <BrandsList className={'logo-top-section-gray'} />
                </div>
                <div className={'main-content'}>
                    {children}
                    <div className={'footer'}>
                        <FooterPrivacy />
                        {isCanadian ? <LanguageSelector /> : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BaseTemplate;
